import { render, staticRenderFns } from "./loading-svg.vue?vue&type=template&id=792cecde&scoped=true&"
import script from "./loading-svg.vue?vue&type=script&lang=js&"
export * from "./loading-svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792cecde",
  null
  
)

export default component.exports